import { Link } from "react-router-dom";
import { LogoMark } from "./LogoMark";

export const Footer = ({ onOrganizer }) => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0D0D12]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <LogoMark className="w-8 h-8" />
            <span className="font-display font-bold tracking-tight">
              WanneerKaartverkoop<span className="text-volt">.nl</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Nooit meer te laat voor jouw favoriete festival, concert of event. Wij tracken elke
            kaartverkoop en pre-sale in Nederland — tot op de seconde.
          </p>
          <a
            href="mailto:info@wanneerkaartverkoop.nl"
            data-testid="footer-email-link"
            className="mt-4 inline-block text-sm font-semibold text-blaze transition-colors hover:text-blaze-hover"
          >
            info@wanneerkaartverkoop.nl
          </a>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Pagina's</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><Link to="/contact" data-testid="footer-contact-link" className="transition-colors hover:text-volt">Contact & event-tips</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-volt">Privacyverklaring</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="transition-colors hover:text-volt">Disclaimer</Link></li>
            <li><Link to="/voorwaarden" data-testid="footer-voorwaarden-link" className="transition-colors hover:text-volt">Algemene Voorwaarden</Link></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-volt">Admin</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Ontdek</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><Link to="/" className="transition-colors hover:text-volt">Festivals</Link></li>
            <li><Link to="/" className="transition-colors hover:text-volt">Concerten</Link></li>
            <li><Link to="/" className="transition-colors hover:text-volt">Sport & Fit</Link></li>
            <li><Link to="/" className="transition-colors hover:text-volt">Raves & Indoor</Link></li>
            <li><Link to="/" className="transition-colors hover:text-volt">Voetbal</Link></li>
            <li>
              {onOrganizer ? (
                <button onClick={onOrganizer} className="transition-colors hover:text-blaze" data-testid="footer-organizer-link">
                  Meld je kaartverkoop aan
                </button>
              ) : (
                <Link to="/contact" data-testid="footer-organizer-link" className="transition-colors hover:text-blaze">
                  Meld je kaartverkoop aan
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-12 border-t border-white/10 pt-8" data-testid="footer-colofon">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Colofon</p>
        <p className="mt-3 text-xs leading-relaxed text-slate-400" data-testid="footer-company-details">
          Wanneerkaartverkoop.nl · KvK 42205037 · BTW NL005581110B78 ·{" "}
          <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze transition-colors hover:text-blaze-hover">
            info@wanneerkaartverkoop.nl
          </a>
        </p>
        <p className="mt-3 max-w-3xl text-xs leading-relaxed text-slate-500" data-testid="footer-affiliate-disclaimer">
          Wanneerkaartverkoop.nl verkoopt zelf geen tickets. Wij verwijzen door naar officiële
          ticketpartners. Wanneer je via onze links een aankoop doet, kunnen wij een kleine
          commissie ontvangen, zonder dat dit jou extra kost.
        </p>
      </div>
      <div className="mt-8 flex flex-col gap-2 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[11px] text-slate-500">© 2026 WanneerKaartverkoop.nl</p>
        <p className="font-mono text-[11px] text-slate-600">
          Alle verkoopdata onder voorbehoud — zie onze <Link to="/disclaimer" className="underline underline-offset-2 hover:text-slate-400">disclaimer</Link>.
        </p>
      </div>
    </div>
  </footer>
);
